import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactHighcharts from '../CommonComponents/Highcharts';
import LoadingChart from '../CommonComponents/LoadingChart';
import { createCustomPropType, isNumeric, isUuid } from '../../js/app/react/validators';

export default class MobileRecommendedTargetAmountChart extends Component {
  constructor(props) {
    super(props);
    this.load = this.load.bind(this);
  }

  UNSAFE_componentWillMount() {
    this.load(this.props, true);
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if (
      newProps.fpId !== this.props.fpId ||
      newProps.clientId !== this.props.clientId ||
      newProps.goalId !== this.props.goalId ||
      newProps.data !== this.props.data
    ) {
      this.load(newProps, true);
    }
  }

  shouldComponentUpdate(newProps) {
    if (
      newProps.fpId === this.props.fpId &&
      newProps.clientId === this.props.clientId &&
      newProps.goalId === this.props.goalId
    ) {
      if (!window.ADV.util.shallowEqual(newProps.chartData, this.props.chartData)) {
        return true;
      }
      if (newProps.showLoading !== this.props.showLoading) {
        return true;
      }
      return false;
    }
    return true;
  }

  // eslint-disable-next-line class-methods-use-this
  load({ goalId, fpId, clientId, fetchData, receiveData, data }, showLoading) {
    if (data) {
      receiveData(
        {
          GoalChart: {
            Chart: data.GoalCharts[0],
            ...data,
          },
        },
        clientId,
      );
    } else {
      fetchData(goalId, fpId, clientId, showLoading);
    }
  }

  render() {
    const { chartData, loading, showLoading, goalId, fpId } = this.props;

    let Content = null;
    if (!chartData && !loading) {
      return null;
    }

    if (showLoading) {
      Content = <LoadingChart />;
    } else if (chartData) {
      Content = (
        <ReactHighcharts
          autoResize
          container={`RecommendedTargetAmountChartContainer-${fpId}-${goalId}`}
          className="RecommendedTargetAmountChartContainer"
          options={chartData}
        />
      );
    } else {
      Content = <LoadingChart />;
    }

    return <section className="RecommendedTargetAmountChart mobile">{Content}</section>;
  }
}

MobileRecommendedTargetAmountChart.propTypes = {
  showLoading: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  fpId: createCustomPropType(isUuid).isRequired,
  data: PropTypes.shape({}).isRequired,
  chartData: PropTypes.shape({}).isRequired,
  goalId: createCustomPropType(isUuid).isRequired,
};
